(() => {
  const labels = JSON.parse(document.getElementById('RbcPriceLabels')?.textContent || '{}');
  const money = (app, amount) => {
    const holder = document.createElement('span');
    holder.innerHTML = app.formatMoney(amount);
    return holder.textContent;
  };
  const fixSummary = (app, block) => {
    const config = block?._getBlockConfig?.();
    if (!config) return;
    const quantity = Number(config.quantity);
    const options = Object.values(config.option_values || {});
    const discount = options.find(option => option.name === '_YmqQb')?.discount;
    if (!discount || Number(discount.type) !== 2 || !(Number(discount.value) > 0) || !(quantity > 0)) return;
    const before = Number(config.price_info?.total_price) + Number(config.o_variant_price) * quantity;
    const after = Math.round(app._discountPrice(before / quantity, discount) * 100) * quantity / 100;
    if (!Number.isFinite(before) || !Number.isFinite(after) || after < 0 || after > before) return;
    const modal = document.getElementById('ymqmodal-option-list');
    const total = modal?.querySelector(`.${app.class_prefix}list-total-price`);
    if (!total) return;
    const oldPrice = document.createElement('s');
    oldPrice.textContent = money(app, before);
    const newPrice = document.createElement('strong');
    newPrice.className = 'rbc-popup-total';
    newPrice.textContent = money(app, after);
    const savings = document.createElement('span');
    savings.className = 'rbc-popup-savings';
    savings.textContent = `${labels.bulk} · ${labels.savings.replace('RBC_AMOUNT', money(app, before - after))}`;
    total.replaceChildren(oldPrice, newPrice, savings);
    const priceCell = modal.querySelector(`.${app.class_prefix}list-table tbody tr:first-child td:last-child`);
    if (priceCell && Number(config.price_info?.total_price) === 0) {
      const unit = document.createElement('strong');
      unit.textContent = `${money(app, after / quantity)} ${labels.each}`;
      const count = document.createElement('div');
      count.textContent = `× ${quantity}`;
      priceCell.replaceChildren(unit, count);
    }
  };
  const install = () => {
    let installed = false;
    for (const app of window.__ymqProductPlugins || []) {
      if (typeof app.optionListModal !== 'function') continue;
      installed = true;
      if (app.optionListModal.rbcClearPricing) continue;
      const original = app.optionListModal;
      const wrapped = function (block, ...args) {
        const result = original.call(this, block, ...args);
        fixSummary(this, block);
        return result;
      };
      wrapped.rbcClearPricing = true;
      app.optionListModal = wrapped;
    }
    return installed;
  };
  if (!install()) {
    let attempts = 0;
    const timer = setInterval(() => {
      if (install() || ++attempts >= 120) clearInterval(timer);
    }, 250);
    window.__ymqOptionReady?.then(install);
  }
})();
